// Escena ESQUEMÁTICA propia de cama + radar según el montaje real (muro, cabecera). No copia
// recursos OEM, no dibuja coordenadas, nube de puntos ni posición: sólo estado y movimiento
// acreditados.
export default function EscenaRadarCama({ presencia, movimientoReciente, montaje = "Muro · cabecera" }) {
  const hay = presencia === true;
  const desconocida = presencia == null;
  const colorCama = hay ? "#0A84FF" : "#8E8E93";
  return (
    <figure data-testid="ekh-escena-radar" data-presencia={desconocida ? "desconocida" : hay ? "si" : "no"}
      className="gv2-panel rounded-xl p-3">
      <svg viewBox="0 0 220 120" className="h-28 w-full" role="img"
        aria-label="Esquema de la cama con el radar montado en la cabecera">
        <rect x="8" y="8" width="204" height="104" rx="8" fill="none" stroke="currentColor"
          strokeOpacity="0.15" />
        {/* radar en muro, cabecera */}
        <rect x="96" y="14" width="28" height="10" rx="3" fill="#01CBE3" />
        <path d="M110 26 L74 58 L146 58 Z" fill={hay ? "#0A84FF" : "#8E8E93"}
          fillOpacity={desconocida ? 0.08 : hay ? 0.22 : 0.1} />
        {/* cama */}
        <rect x="62" y="60" width="96" height="40" rx="6" fill="none" stroke={colorCama}
          strokeOpacity="0.8" strokeWidth="2" />
        <rect x="68" y="66" width="26" height="14" rx="3" fill={colorCama} fillOpacity="0.35" />
        {hay && (
          <ellipse cx="118" cy="80" rx="22" ry="11" fill={colorCama} fillOpacity="0.45">
            {movimientoReciente && (
              <animate attributeName="fill-opacity" values="0.45;0.2;0.45" dur="1.8s"
                repeatCount="indefinite" />
            )}
          </ellipse>
        )}
      </svg>
      <figcaption className="mt-1 text-[10px] text-slate-400">
        Esquema propio del montaje ({montaje}). Representa presencia y movimiento recibidos; no es
        una posición medida ni una nube de puntos.
      </figcaption>
    </figure>
  );
}
